import React from 'react';
import Box from '@liquidweb-dev/undercurrent/Box';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import { useSelector } from 'react-redux';
import appConfigSelectors from 'modules/appConfig/selectors';
import useLeftHandLayout, { LeftHandLayoutProvider } from './context';
import NavDialogsProvider from './NavDialogsProvider';
import LargeNav from './LargeNav';
import SmallNav from './SmallNav';
import MasqueradeNote from './common/MasqueradeNote';

/**
 * @param {React.ComponentProps<typeof Stack>} props
 */
export function LeftHandLayoutContent(props) {
	const { children, sx, ...stackProps } = props;

	const { screenSize, leftSize, topSize } = useLeftHandLayout();

	const { headsUpDisplay } = useSelector(appConfigSelectors.getAppConfig);

	return (
		<Stack
			{...stackProps}
			sx={combineSx(
				{
					paddingLeft: `${leftSize}px`,
					backgroundColor: (theme) => theme.vars.palette.uc.bg.weak,
				},
				sx,
			)}
		>
			<NavDialogsProvider>
				{screenSize === 'small' ? <SmallNav /> : <LargeNav />}
			</NavDialogsProvider>
			<Box
				component="main"
				sx={[
					{
						flex: '0% 1 1',
						display: 'flex',
						flexDirection: 'column',
						borderRadius: (theme) => theme.borderRadius.roundedSm,
						paddingTop: `${topSize}px`,
						bgcolor: (theme) => theme.vars.palette.uc.bg.main,
					},
					screenSize !== 'small' && { margin: 100, boxShadow: 1 },

					// account for height of HeadsUpDisplay
					Boolean(headsUpDisplay) && { paddingBottom: '32px' },
				]}
			>
				{screenSize === 'small' && <MasqueradeNote />}
				{children}
			</Box>
		</Stack>
	);
}

/**
 * @typedef {React.ComponentProps<typeof Stack> & React.ComponentProps<typeof LeftHandLayoutProvider>} LeftHandLayoutPropsI
 */

/**
 * @param {LeftHandLayoutPropsI} props
 */
export function LeftHandLayout(props) {
	const { appPath, linkComponent, linkProp, roles, ...stackProps } = props;

	return (
		<LeftHandLayoutProvider
			appPath={appPath}
			linkComponent={linkComponent}
			linkProp={linkProp}
			roles={roles}
		>
			<LeftHandLayoutContent {...stackProps} />
		</LeftHandLayoutProvider>
	);
}

export default LeftHandLayout;
